<script>
// Carousel
import AppCarousel from './components/app-carousel';
import AppCarouselItem from './components/app-carousel-item';
import AppCarouselButton from './components/app-carousel-button';

// Modal
import AppModal from './components/app-modal';
import AppModalButton from './components/app-modal-button';

import AppScrollTop from './components/app-scroll-top';

export default {
	components: {
		AppCarousel,
		AppCarouselItem,
		AppCarouselButton,
		AppModal,
		AppModalButton,
		AppScrollTop,
	},
};
</script>

<style src="./styles/utilities.css"></style>
